// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JHWC7WAqOIzsaT {
  position: relative;
  min-height: 36px;
  border-radius: 8px;
  background-color: var(--ds-surface-raised, #ffffff);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
  color: var(--ds-text, #172b4d);
  cursor: pointer;
  scroll-margin: 8px;
}
.XpRtBItFRSeuWI {
  display: flow-root;
  position: relative;
  z-index: 10;
  min-height: 24px;
  padding: 8px 12px 4px;
}
.NHIMaJNu_3MGEF {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  background-color: rgba(255, 255, 255, 0.7);
}
:where(html[data-color-mode='dark']) .NHIMaJNu_3MGEF {
  background-color: rgba(29, 33, 37, 0.7);
}
.rZbD0IuG2SfEkv {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  padding: 8px 12px;
  border-radius: 3px;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  box-sizing: border-box;
  border: none;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  width: 100%;
  margin-bottom: 4px;
  padding: 0;
  overflow: hidden;
  overflow-wrap: break-word;
  resize: none;
}
.rZbD0IuG2SfEkv:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.rZbD0IuG2SfEkv:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.rZbD0IuG2SfEkv:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.rZbD0IuG2SfEkv[readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.rZbD0IuG2SfEkv.ZQ2F7Aui9qtsq2 {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.rZbD0IuG2SfEkv.ZQ2F7Aui9qtsq2:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.rZbD0IuG2SfEkv.ZQ2F7Aui9qtsq2:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.rZbD0IuG2SfEkv.ovvQE1qdvcDZTB {
  width: 100%;
}
.rZbD0IuG2SfEkv::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.rZbD0IuG2SfEkv,
.rZbD0IuG2SfEkv:hover,
.rZbD0IuG2SfEkv:focus {
  background-color: unset;
  box-shadow: revert;
}
.ZmHvmWkNGCxkHa {
  margin-top: 8px;
  margin-bottom: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardFront": `JHWC7WAqOIzsaT`,
	"details": `XpRtBItFRSeuWI`,
	"stickersBackdrop": `NHIMaJNu_3MGEF`,
	"cardNameEditor": `rZbD0IuG2SfEkv`,
	"input-error": `ZQ2F7Aui9qtsq2`,
	"full": `ovvQE1qdvcDZTB`,
	"saveButton": `ZmHvmWkNGCxkHa`
};
export default ___CSS_LOADER_EXPORT___;
